import React, { useContext, useEffect, useState } from 'react';
import Layout from './Layout';
import { Users, CalendarCheck, CalendarX } from 'lucide-react';
import EventContext from '../contexts/EventContext';
import { Link } from 'react-router-dom';
import RegistrationDashbord from './RegistrationDashbord';
import { API_URL } from '../config';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import useGetPartenaires from '../customHooks/useGetPartenaires';
import RegistrationDashbordNav from './RegistrationDashbordNav';
import ContactProfileBanner from './ContactProfileBanner';

const StatCard = ({ icon, title, value, colorClass }) => (
    <div className="bg-white dark:bg-neutral-900 border border-gray-100 dark:border-neutral-800 p-6 rounded-xl shadow-sm flex items-center space-x-4">
        <div className={`p-3 rounded-full ${colorClass}`}>{icon}</div>
        <div>
            <p className="text-sm text-gray-500 dark:text-neutral-400">{title}</p>
            <p className="text-2xl font-bold text-gray-800 dark:text-white">{value}</p>
        </div>
    </div>
);


const ProfileSection = ({ idContact }) => {
    const { currentEvent } = useContext(EventContext);

    const [contact, setContact] = useState(null);

    const { partenaireList } = useGetPartenaires({ params: `AND c.id_contact=${idContact} AND cf.id_event=${currentEvent?.id_event}  ` });

    useEffect(() => {
        if (!idContact) return;
        const controller = new AbortController();
        fetch(`${API_URL}?action=getContact&id_contact=${idContact}`, { signal: controller.signal })
            .then(res => res.json())
            .then(data => setContact(data))
            .catch(err => { if (err.name !== 'AbortError') console.error(err); });
        return () => controller.abort();
    }, [idContact]);


    if (!contact) return null;

    return (
        <div className="bg-white dark:bg-neutral-900 border border-gray-100 dark:border-neutral-800 p-4 rounded-xl shadow-sm mb-8 flex items-center space-x-6">
            <img
                src={contact.photos.large}
                alt={`Profil de ${contact.prenom} ${contact.nom}`}
                className="w-20 h-20 rounded-full object-cover border-4 border-gray-100 dark:border-neutral-700 shrink-0"
            />
            <div className="min-w-0">
                <h2 className="text-2xl font-bold text-gray-800 dark:text-white truncate">{contact.prenom} {contact.nom} — {contact.societe}</h2>
                <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-2">
                    {contact.mail && (
                        <span className="text-sm text-gray-500 dark:text-neutral-400">
                            Email : <a href={`mailto:${contact.mail}`} className="text-e2o-500 hover:underline">{contact.mail}</a>
                        </span>
                    )}
                    {contact.port && <span className="text-sm text-gray-500 dark:text-neutral-400">Mobile : {contact.port}</span>}
                </div>
                {partenaireList && partenaireList.length > 0 && (
                    <div className="flex flex-wrap items-center gap-2 mt-2">
                        {partenaireList.map((partenaire, index) => (
                            <div key={index} className="rounded-full px-3 py-1 bg-gray-100 dark:bg-neutral-800 text-gray-600 dark:text-neutral-300 text-xs font-medium">
                                {partenaire.conferencier_statut?.libelle}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    )

}




const RegistrationDashboardLayout = ({ children, title, description, stats, isAdmin, profile }) => {
    const { currentEvent } = useContext(EventContext);
    const { ownerIdContact } = useParams();



    return (
        <Layout

        >
            <div className="p-8 bg-gray-50 dark:bg-neutral-950 min-h-screen">

                <header className="mb-8">
                    <h1 className="text-4xl font-bold text-gray-800 dark:text-white pt-5">Dashboard {currentEvent?.nom}</h1>
                    <p className="text-gray-600 dark:text-neutral-400 mt-1">Suivez les inscriptions et gérez les créneaux de rendez-vous</p>
                </header>

                <ProfileSection idContact={ownerIdContact} />

                {/* {ownerIdContact && <ContactProfileBanner idContact={ownerIdContact} />} */}

                {stats && (
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                        <StatCard
                            icon={<Users className="h-6 w-6 text-blue-600" />}
                            title="Total Inscriptions"
                            value={stats.total}
                            colorClass="bg-blue-100" />
                        <StatCard icon={<CalendarCheck className="h-6 w-6 text-green-600" />} title="Créneaux Réservés" value={stats.booked} colorClass="bg-green-100" />
                        <StatCard icon={<CalendarX className="h-6 w-6 text-orange-600" />} title="Créneaux Disponibles" value={stats.available} colorClass="bg-orange-100" />
                    </div>
                )}

                <RegistrationDashbordNav
                    isAdmin={isAdmin}
                    profile={profile}
                />



                <main>
                    {children}
                </main>
            </div>
        </Layout>
    );
};

export default RegistrationDashboardLayout;